var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3678_682)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3678_682)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.27607C8.28648 5.27607 5.27607 8.28648 5.27607 12C5.27607 15.7135 8.28648 18.7239 12 18.7239C15.7135 18.7239 18.7239 15.7135 18.7239 12C18.7239 8.28648 15.7135 5.27607 12 5.27607ZM4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12.2066 8.97637C11.8411 8.91367 11.4651 8.98236 11.1453 9.17029C10.8256 9.35822 10.5826 9.65326 10.4596 10.0031C10.3426 10.3356 9.97835 10.5102 9.64594 10.3933C9.31353 10.2764 9.13885 9.91209 9.25579 9.57968C9.47887 8.94552 9.9192 8.41077 10.4988 8.07015C11.0783 7.72953 11.7598 7.60502 12.4224 7.71867C13.0849 7.83232 13.6859 8.17679 14.1188 8.69109C14.5516 9.20521 14.7886 9.85587 14.7877 10.5279C14.7876 11.6026 13.99 12.3212 13.3993 12.7149C13.0846 12.9248 12.7743 13.0794 12.5453 13.1812C12.4299 13.2325 12.3328 13.2714 12.2631 13.2979C12.2282 13.3112 12.2 13.3215 12.1797 13.3287L12.155 13.3374L12.1473 13.34L12.1447 13.3409L12.1437 13.3412C12.1435 13.3413 12.1429 13.3415 11.9411 12.7362L12.1437 13.3412C11.8094 13.4527 11.4472 13.2723 11.3358 12.938C11.2245 12.6041 11.4046 12.2432 11.7381 12.1313C11.738 12.1313 11.7382 12.1313 11.7381 12.1313L11.7522 12.1264C11.7641 12.1221 11.7834 12.1152 11.8089 12.1054C11.8599 12.086 11.9354 12.0558 12.0271 12.0151C12.2122 11.9328 12.4541 11.8114 12.6915 11.6532C13.2051 11.3108 13.5117 10.9251 13.5117 10.5276C13.5122 10.1567 13.3815 9.79663 13.1426 9.51288C12.9038 9.22913 12.5722 9.03907 12.2066 8.97637ZM11.362 15.681C11.362 15.3286 11.6476 15.0429 12 15.0429H12.0074C12.3597 15.0429 12.6454 15.3286 12.6454 15.681C12.6454 16.0334 12.3597 16.319 12.0074 16.319H12C11.6476 16.319 11.362 16.0334 11.362 15.681Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3678_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3678_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleQuestion);
export default __webpack_public_path__ + "static/media/circleQuestion.05f176e8.svg";
export { ForwardRef as ReactComponent };